export default "__VITE_ASSET__7cec5bb8__"